
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio",
      function () {
        return require("private-next-pages/portfolio/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portfolio"])
      });
    }
  